import { Select } from "antd";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import axios from "axios";

const SubplantPicker2 = ({
	onChange,
	value,
	plant,
	isComplete,
	setSubplant,
}) => {
	const [options, setOptions] = useState([]);
	const [disabled, setDisabled] = useState(true);
	const [currentValue, setCurrentValue] = useState(value);

	useEffect(() => {
		getSubplants();
	}, [plant]);

	const onChangeSubplant = (value) => {
		setCurrentValue(value);
		onChange(value);
	};

	const getSubplants = async () => {
		const url = api + `/plant/${plant}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let list = [];
			if (isComplete) {
				list.push({ value: "All", label: "All" });
			}
			data.subplants
				.filter((value) => value.active)
				.map((item) => {
					list.push({
						value: item.name,
						label: item.name,
					});
				});
			setOptions(list);
			const subplantExist = list.find((i) => i.value === value);
			if (!subplantExist) {
				setCurrentValue("All");
				setSubplant("All");
			}
			setDisabled(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	return (
		<Select
			size="large"
			options={options}
			value={currentValue}
			onChange={onChangeSubplant}
			style={{ width: "100%" }}
			loading={disabled}
			disabled={disabled}
		/>
	);
};

export default SubplantPicker2;
